import { createContext } from "react";

export const MicrositeComponentCtx = createContext<{
  id: string;
  index: number;
}>({ id: "", index: -1 });
